import React from 'react'
import { Card, CardBody, CardTitle } from "reactstrap"
import { HistorialSolicitudesHorasExtras } from '../SolicitudPagoHE/TypesSolicitudPagoHE';
import NumberFormat from 'react-number-format';
import PdfSVG from "assets/icons/Permisos/PDF(azul).svg"
import { DownloadDocument2 } from 'helpers/files';
import { PrimeraLetraMayuscula } from './HistorialSolicitudes';


// Función para seleccionar un color
function getColor(index: number) {
    const colors = ['#F0915E', '#FF9597', '#CC74BA'];
    return colors[index % colors.length];  // Usa el módulo para rotar a través de los colores
}

type PropsCardHistorialSolicitudHE = {
    indice: number,
    anio: number,
    historiaAnio: HistorialSolicitudesHorasExtras[],
    onClickDocumento: (historia: HistorialSolicitudesHorasExtras) => Promise<void>
}

export default function CardHistoriaSolicitudHE(props: PropsCardHistorialSolicitudHE) {

    const TITULO_CARD = `Solicitudes ${props.anio}`;

    const color = getColor(props.indice)

    const ESTADOS_SOLICITUDES_NEGADAS:string[] = ["ND","NT"]

    return (
        <Card className="">
            <CardTitle className="cardHeaderHistorialHE" style={{ backgroundColor: color }}  >
                <div className="containerTituloHistorialHE">
                    {TITULO_CARD}
                </div>
            </CardTitle>
            <CardBody className="cardBodyHistorialHE">
                {
                    props.historiaAnio.map((v, i) => {
                        return (
                            <div key={"cardSolicitudHE " + i} className="containerCHE">
                                {/* <div className="containerValorCHE"> */}

                                {/* </div> */}
                                <div className="first">{`${PrimeraLetraMayuscula(v.mesDescripcion)}:`}</div>
                                {
                                    v.estado.trim() === "VE" ? "" :
                                        <NumberFormat
                                            className='first-valorHE'
                                            value={v.valor}
                                            displayType={'text'}
                                            thousandSeparator={'.'}
                                            decimalSeparator={','}
                                            prefix={'$'}
                                            decimalScale={2}
                                            fixedDecimalScale={true}
                                        />
                                }

                                <div className={`second ${v.estado.trim() === "VE" ? "small-error" : ""}`}>
                                    {
                                        v.estadoDescripcionHistoria
                                    }

                                </div>

                                <div className={"third"}>
                                    {
                                        v.refarchivo && 
                                        <img
                                            src={PdfSVG} // Cambia la ruta al lugar donde esté almacenado tu SVG
                                            className="acciones"
                                            alt={`Solicitud de Pago de HE del mes de ${v.mes}`}
                                            data-toggle="tooltip"
                                            data-placement="top"
                                            title={`Solicitud de Pago de HE del mes de ${v.mes}`}
                                            style={{ width: 24, height: 24 }} // Ajusta el tamaño según necesites
                                            onClick={() => { DownloadDocument2(v.refarchivo, `Solicitud de Pago de HE del mes de ${v.mes}`  ) }}
                                        />
                                    }
                                </div>




                            </div>
                        )
                    })
                }
            </CardBody>
        </Card>
    )
}
